import {useInstance} from 'react-ioc'
import {AppConfigStore} from 'new/stores/AppConfigStore'

///////////////////////////////////////////////////////////////////////////////

export const useAppConfig = () => {
  return useInstance(AppConfigStore).data
}
